import React, {useState} from 'react';
import styled from 'styled-components';
import InfoBox from './InfoBox';
import {distanciaAteHoje,formata} from '../../Helpers/date';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { DialogContent } from '@material-ui/core';
import Detalhes from './Detalhes';
import Foto from './Foto';
import { orderBy } from 'lodash-es';
import InfoBoxSalario from './InfoBoxSalario';
import FuncionariosHeader from './Header';
import { ordenaPor } from './helpers';


export default function Tabela(props) {
  const { empresaId, funcionarios, dptosById, qtde } = props;
  let [ campoOrdenar, setCampoOrdenar ] = useState('Codigo');
  let [ ordenaAscDesc, setOrdenaAscDesc ] = useState('asc');

  const [ modal, setModal ] = useState(false);
  const m = {
    isOpen: Boolean(modal),
    open: (id_) => () => setModal(id_),
    close: () => setModal(false)
  }
  return (
    <>
    <Card style={{ padding: "10px" }}>
      <FuncionariosHeader 
        {...props}
        campoOrdenar={campoOrdenar}
        setCampoOrdenar={setCampoOrdenar}
        ordenaAscDesc={ordenaAscDesc}
        setOrdenaAscDesc={setOrdenaAscDesc}
      />
      <FuncionariosList {...props} m={m} campoOrdenar={campoOrdenar} ordenaAscDesc={ordenaAscDesc} />
    </Card>
    <Dialog
      maxWidth='md'
      open={m.isOpen}
      onClose={m.close}
      scroll="body"
    >
      <DialogContent>
        <Detalhes
          empregadoId={modal}
          funcionarios={funcionarios}
          dptosById={dptosById}
        />
      </DialogContent>
      {/* <Contracheque
        empresaId={empresaId}
        empregadoId={modal}
      /> */}
      {/* <VinculoCadastro empresaId={empresaId} /> */}
    </Dialog>
    </>
  )
}


function FuncionariosList (props) {
  let { funcionarios, dptosById, m, campoOrdenar, ordenaAscDesc } = props;
  let sorted_funcionarios = orderBy(
    funcionarios,
    ordenaPor.find(e => e.Codigo == campoOrdenar).fn || campoOrdenar,
    ordenaAscDesc
  )
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    }}>
    {sorted_funcionarios.map(f => {
      const { Nome:NomeDpto="" } = dptosById[f.DptoID];
      return (
        <FuncionarioCard
          key={f.Codigo}
        >
          <Foto src={f.Foto} />
          <MainBox>
            <div>
              {f.Nome}
              <span className="codigo">
                [{f.Codigo}]
              </span>
            </div>
            <div>
              <i className={`fas fa-users`}></i>
              {NomeDpto}
            </div>
            <div>
              <i className={`fas fa-id-badge`}></i>
              {f.Cargo}
            </div>
            <div>
              <i className={`fas fa-home`}></i>
              {f.Bairro}, {f.Cidade}
            </div>
          </MainBox>
          <InfoBox
            iconName="birthday-cake"
            label={"Aniversário"}
            value={formata(f.DataNascimento)}
            details={distanciaAteHoje(f.DataNascimento)}
          />
          <InfoBox
            iconName="umbrella-beach"
            label={"Vencimento Férias"}
            value={formata(f.VencimentoFerias)}
            details={distanciaAteHoje(f.VencimentoFerias)}
          />
          <InfoBox
            iconName="sign-in-alt"
            label={"Admissão"}
            value={formata(f.Admissao)}
            details={distanciaAteHoje(f.Admissao)}
          />
          <InfoBoxSalario f={f} />
          <Controls>
            <Button 
              variant="outlined"
              color="primary"
              onClick={m.open(f.Codigo)}
            >
              Detalhes
            </Button>
          </Controls>
        </FuncionarioCard>
    )})}
    </div>
  )
}

const Controls = styled.div`
  grid-area: ctrl;
  display: flex;
  flex-direction: column;
  padding: 10px;
  justify-content: center;
`

const FuncionarioCard = styled.div`
  margin: 4px;
  padding: 4px 10px 14px 0px;
  border: 1px solid #ccc;
  border-radius: 3px;
  display: grid;
  grid-template-columns: 100px 350px 150px 150px 150px;
  grid-template-rows: auto auto;
  grid-template-areas:
    "foto main     . . ctrl"
    "foto main     . . ctrl";
`
const MainBox = styled.span`
  grid-area: main;
  display: flex;
  flex-direction: column;
  justify-content: center;
  & > div {
    font-size: 14px;
    display: flex;
  }
  & > div > .fas {
    margin-left: 3px;
    margin-bottom: 2px;
    width: 30px;
    text-align: center;
  }
  & > div:first-child {
    display: inline-block;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 5px;
  }
  & .codigo {
    margin-left: 5px;
    font-size: 12px;
    color: gray;
  }
`
